'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
/**
 * This is utilised as part of the migration to ensure that valeus that are changed in the new players state key
 * affects changes in the legacy VI state. This goes hand in hand with calling `Redux` actions from the legacy actions.
 * We use a export function and a property on legacyState:
 * - setState(..) - Used to update a single property on the internal map
 * - rawState - Exported direct state object, used only for the migration and bypasses the StateSnapshot
 *
 * Note: These are temporary
 */


exports.insertPlayable = insertPlayable;
exports.pause = pause;
exports.play = play;
exports.removePlayable = removePlayable;
exports.setAdBegan = setAdBegan;
exports.setAdEnded = setAdEnded;
exports.setAspectRatio = setAspectRatio;
exports.setAutoAdvance = setAutoAdvance;
exports.setAutoPlay = setAutoPlay;
exports.disableAudio = disableAudio;
exports.setStream = setStream;
exports.setStreamInternal = setStreamInternal;
exports.setSwitchingStreams = setSwitchingStreams;
exports.setCanPlay = setCanPlay;
exports.setFocus = setFocus;
exports.setLooping = setLooping;
exports.setMute = setMute;
exports.setPlayables = setPlayables;
exports.setPlaybackRate = setPlaybackRate;
exports.setPlayingIndex = setPlayingIndex;
exports.reorderPlayable = reorderPlayable;
exports.setQualities = setQualities;
exports.setQuality = setQuality;
exports.setQueueEnded = setQueueEnded;
exports.setSeeking = setSeeking;
exports.setVolume = setVolume;
exports.toggleFullscreen = toggleFullscreen;
exports.setContextMenu = setContextMenu;
exports.setDurationMs = setDurationMs;
exports.setExpectedDurationMs = setExpectedDurationMs;
exports.setLive = setLive;
exports.updatePlayables = updatePlayables;
exports.setError = setError;
exports.setDimensions = setDimensions;

var _immutable = require('immutable');

var _QualityRecord = require('../../records/QualityRecord');

var _QualityRecord2 = _interopRequireDefault(_QualityRecord);

var _State = require('../../../shared/VideoStore/State');

var _State2 = _interopRequireDefault(_State);

var _store = require('../../../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QUALITY_CHANGE_LOADING = 'qualityChangeLoading';
var AUTO_LABEL = 'Auto';

var updateLegacyState = function updateLegacyState(playerId, key, value) {
  var rawState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var firstPlayerId = Object.keys(_store2.default.storeInstance().getState().players)[0];
  if (playerId === firstPlayerId) {
    if (rawState) {
      _State2.default.rawState[key] = value;
      return;
    }
    _State2.default.setState(key, value);
  }
};

function insertPlayable(state, action) {
  var playables = state[action.playerId].playables.splice(action.indexOfInsert, 0, action.playable);

  state[action.playerId] = state[action.playerId].withMutations(function (player) {
    player.set('playables', playables);
    player.set('playingIndex', action.playingIndex);
  });

  updateLegacyState(action.playerId, 'playables', playables.toJS());
  updateLegacyState(action.playerId, 'playingIndex', action.playingIndex);

  return Object.assign({}, state);
}

function pause(state, action) {
  state[action.playerId] = state[action.playerId].set('paused', true);
  updateLegacyState(action.playerId, 'paused', true);
  return Object.assign({}, state);
}

function play(state, action) {
  state[action.playerId] = state[action.playerId].set('paused', false);
  updateLegacyState(action.playerId, 'paused', false);
  return Object.assign({}, state);
}

function removePlayable(state, action) {
  var playables = state[action.playerId].playables.splice(action.indexOfDelete, 1);

  state[action.playerId] = state[action.playerId].withMutations(function (player) {
    player.set('playables', playables);
    player.set('playingIndex', action.playingIndex);
  });

  updateLegacyState(action.playerId, 'playables', playables.toJS());
  updateLegacyState(action.playerId, 'playingIndex', action.playingIndex);

  return Object.assign({}, state);
}

function setAdBegan(state, action) {
  state[action.playerId] = state[action.playerId].set('adBegan', action.adBegan);
  return Object.assign({}, state);
}

function setAdEnded(state, action) {
  state[action.playerId] = state[action.playerId].set('adEnded', action.adEnded);
  return Object.assign({}, state);
}

function setAspectRatio(state, action) {
  state[action.playerId] = state[action.playerId].set('aspectRatio', action.aspectRatio);
  updateLegacyState(action.playerId, 'aspectRatio', action.aspectRatio);
  return Object.assign({}, state);
}

function setAutoAdvance(state, action) {
  state[action.playerId] = state[action.playerId].set('autoAdvance', action.autoAdvance);
  return Object.assign({}, state);
}

function setAutoPlay(state, action) {
  state[action.playerId] = state[action.playerId].set('autoplay', action.autoplay);
  updateLegacyState(action.playerId, 'autoplay', action.autoplay);
  return Object.assign({}, state);
}

function disableAudio(state, action) {
  state[action.playerId] = state[action.playerId].set('audioDisabled', action.audioDisabled);
  return Object.assign({}, state);
}

function setStream(state, action) {
  var player = state[action.playerId];

  state[action.playerId] = state[action.playerId].withMutations(function (map) {
    map.set('selectedStreamId', action.selectedStreamId).set('switchingStreams', action.seekToTime);

    var playables = map.get('playables');
    var playable = playables.get(map.playingIndex);

    var currentStream = playable.streams.find(function (s) {
      return s.selected === true;
    });

    if (currentStream) {
      currentStream.selected = false;
    }

    playable.streams.find(function (s) {
      return s.id === action.selectedStreamId;
    }).selected = true;

    map.set('playables', playables.set(player.playingIndex, playable));
  });

  return Object.assign({}, state);
}

function setStreamInternal(state, action) {
  state[action.playerId] = state[action.playerId].withMutations(function (map) {
    map.set('selectedStreamId', action.selectedStreamId).set('switchingStreams', -1);
  });
  return Object.assign({}, state);
}

function setSwitchingStreams(state, action) {
  state[action.playerId] = state[action.playerId].set('switchingStreams', action.value);
  return Object.assign({}, state);
}

function setCanPlay(state, action) {
  state[action.playerId] = state[action.playerId].set('canPlay', action.canPlay);
  updateLegacyState(action.playerId, 'canPlay', action.canPlay);
  return Object.assign({}, state);
}
function setFocus(state, action) {
  state[action.playerId] = state[action.playerId].set('focused', action.focused);
  updateLegacyState(action.playerId, 'focused', action.focused);
  return Object.assign({}, state);
}

function setLooping(state, action) {
  var loop = state[action.playerId].loop;
  loop = loop.withMutations(function (map) {
    map.set('isLooping', action.options.isLooping);
    map.set('startTimeMs', action.options.startTimeMs);
    map.set('endTimeMs', action.options.endTimeMs);
  });

  state[action.playerId] = state[action.playerId].set('loop', loop);
  updateLegacyState(action.playerId, 'loop', loop.toJS());
  return Object.assign({}, state);
}

function setMute(state, action) {
  state[action.playerId] = state[action.playerId].set('muted', action.mute);
  updateLegacyState(action.playerId, 'muted', action.mute);
  return Object.assign({}, state);
}

function setPlayables(state, action) {
  var playables = (0, _immutable.List)(action.playables);
  state[action.playerId] = state[action.playerId].set('playables', playables);

  var firstPlayable = playables.get(0) || {};
  if (firstPlayable.streams && firstPlayable.streams.length > 0) {
    var stream = firstPlayable.streams.find(function (s) {
      return s.selected === true;
    }) || firstPlayable.streams[0];
    state[action.playerId] = state[action.playerId].set('selectedStreamId', stream.id);
  }

  updateLegacyState(action.playerId, 'playables', action.playables);
  return Object.assign({}, state);
}

function setPlaybackRate(state, action) {
  state[action.playerId] = state[action.playerId].set('playbackRate', action.playbackRate);
  updateLegacyState(action.playerId, 'playbackRate', action.playbackRate);
  return Object.assign({}, state);
}

function setPlayingIndex(state, action) {
  var playable = state[action.playerId].playables.get(action.playingIndex);
  var streams = playable && playable.streams && playable.streams.length;
  var streamId = 0;

  if (streams) {
    var selectedStream = streams && playable.streams.find(function (s) {
      return s.selected === true;
    });
    streamId = selectedStream && selectedStream.id || playable.streams[0].id;
  }

  state[action.playerId] = state[action.playerId].set('selectedStreamId', streamId);
  state[action.playerId] = state[action.playerId].set('playingIndex', action.playingIndex);
  updateLegacyState(action.playerId, 'playingIndex', action.playingIndex, true);
  return Object.assign({}, state);
}

function reorderPlayable(state, action) {
  var playable = state[action.playerId].playables.get(action.sourceIndex);
  var playables = state[action.playerId].playables.splice(action.sourceIndex, 1).splice(action.destinationIndex, 0, playable);

  state[action.playerId] = state[action.playerId].withMutations(function (player) {
    player.set('playables', playables);
  });

  updateLegacyState(action.playerId, 'playables', playables.toJS());

  var reorderPlayableState = Object.assign({}, state);

  // Also set the playing index back to the reordered playable.
  var reorderedWithPlayingIndexState = setPlayingIndex(reorderPlayableState, action);
  return reorderedWithPlayingIndexState;
}

function setQualities(state, action) {
  state[action.playerId] = state[action.playerId].withMutations(function (player) {
    if (action.qualities.length > 0) {
      var qualityCollection = (0, _immutable.List)();
      action.qualities.forEach(function (q) {
        qualityCollection = qualityCollection.push(new _QualityRecord2.default(_extends({}, q)));
      });
      player.set('qualities', qualityCollection);
    } else {
      player.set('qualities', (0, _immutable.List)());
    }
  });
  updateLegacyState(action.playerId, 'qualities', state[action.playerId].get('qualities'));
  return Object.assign({}, state);
}

function setQuality(state, action) {
  var playerQuality = state[action.playerId].get('currentQuality');
  if (!action.currentQuality) {
    return Object.assign({}, state);
  }
  var quality = action.currentQuality.toJS ? action.currentQuality : new _QualityRecord2.default(action.currentQuality);

  state[action.playerId] = state[action.playerId].withMutations(function (player) {
    if (action.currentQuality.label !== AUTO_LABEL) {
      if (!playerQuality || quality.key !== playerQuality.get('key')) {
        player.set('currentQuality', quality);
        updateLegacyState(action.playerId, 'currentQuality', quality);
      }
      if (playerQuality && quality.key === playerQuality.get('key')) {
        player.set(QUALITY_CHANGE_LOADING, false);
        updateLegacyState(action.playerId, QUALITY_CHANGE_LOADING, false);
      } else {
        player.set(QUALITY_CHANGE_LOADING, action.qualityChangeLoading);
        updateLegacyState(action.playerId, QUALITY_CHANGE_LOADING, action.qualityChangeLoading);
      }
    }
  });

  return Object.assign({}, state);
}

function setQueueEnded(state, action) {
  state[action.playerId] = state[action.playerId].set('queueEnded', action.value);
  updateLegacyState(action.playerId, 'queueEnded', action.value);
  return Object.assign({}, state);
}

function setSeeking(state, action) {
  state[action.playerId] = state[action.playerId].set('seeking', action.value);
  updateLegacyState(action.playerId, 'isSeeking', action.value);
  return Object.assign({}, state);
}

function setVolume(state, action) {
  state[action.playerId] = state[action.playerId].set('volume', action.volume);
  state[action.playerId] = state[action.playerId].set('muted', action.muted);
  updateLegacyState(action.playerId, 'volume', action.volume);
  updateLegacyState(action.playerId, 'muted', action.muted);
  return Object.assign({}, state);
}

function toggleFullscreen(state, action) {
  state[action.playerId] = state[action.playerId].set('fullscreen', action.fullscreen);
  updateLegacyState(action.playerId, 'fullscreen', action.fullscreen);
  return Object.assign({}, state);
}

function setContextMenu(state, action) {
  state[action.playerId] = state[action.playerId].set('contextMenuOpen', action.contextMenuOpen);
  updateLegacyState(action.playerId, 'contextMenuOpen', action.contextMenuOpen);
  return Object.assign({}, state);
}

function setDurationMs(state, action) {
  state[action.playerId] = state[action.playerId].set('durationMs', action.durationMs);
  updateLegacyState(action.playerId, 'durationMs', action.durationMs);
  return Object.assign({}, state);
}

function setExpectedDurationMs(state, action) {
  state[action.playerId] = state[action.playerId].set('expectedDurationMs', action.expectedDurationMs);
  updateLegacyState(action.playerId, 'expectedDurationMs', action.expectedDurationMs);
  return Object.assign({}, state);
}

function setLive(state, action) {
  state[action.playerId] = state[action.playerId].set('live', action.live);
  updateLegacyState(action.playerId, 'live', action.live);
  return Object.assign({}, state);
}

function updatePlayables(state, action) {
  var playables = (0, _immutable.List)(action.playables);
  state[action.playerId] = state[action.playerId].set('playables', playables);

  updateLegacyState(action.playerId, 'playables', action.playables);
  return Object.assign({}, state);
}

function setError(state, action) {
  state[action.playerId] = state[action.playerId].set('error', action.error);
  return Object.assign({}, state);
}

function setDimensions(state, action) {
  state[action.playerId] = state[action.playerId].set('width', action.width);
  state[action.playerId] = state[action.playerId].set('height', action.height);
  return Object.assign({}, state);
}